import React, { useState } from 'react';
import { GetEmployeeDetails, PostRegistration } from '../../service/SessionAPI'; // Import your API methods
import { Toast } from './Toast';

export const AddMemberModal = ({ sessionId, slotId, sessionGrade, onClose, onToast }) => {
    const [emailId, setEmailId] = useState('');
    const [employeeDetails, setEmployeeDetails] = useState({
        emp_id: '',
        userid: '',
        emp_name: '',
        role: '',
        practice: '',
        grade: '',
    });
    const [error, setError] = useState('');
    const [isGradeValid, setIsGradeValid] = useState(false);

    const handleEmailChange = (e) => {
        setEmailId(e.target.value);
        setEmployeeDetails({
            emp_id: '',
            userid: '',
            emp_name: '',
            role: '',
            practice: '',
            grade: '',
        }); // Reset employee details on email change
        setError('');
        setIsGradeValid(false);
    };

    const handleEmailBlur = async () => {
        if (emailId) {
            try {
                const response = await GetEmployeeDetails(emailId);
                if (response.data.code === 200) {
                    const employee = response.data.data;
                    setEmployeeDetails(employee);
                } else {
                    setIsGradeValid(false);
                    setError('Employee not found');
                }
            } catch (err) {
                console.error('Error fetching employee details:', err);
                setIsGradeValid(false);
                setError('Error fetching employee details');
            }
        }
    };
    const handleAddMember = async () => {
        if (employeeDetails.emp_id) {
            const payload = {
                session_id: sessionId,
                slot_id: slotId,
                emp_id: employeeDetails.emp_id,
                status: 'Register',
            };

            try {
                const response = await PostRegistration(payload);
                if (response.data.code === 200) {
                    Toast.success('Member added successfully');
                    onClose();
                } else if (
                    response.data.code === 500 &&
                    Array.isArray(response.data.data) &&
                    response.data.data[0]?.message === 'employee already registered for this session'
                ) {
                    Toast.error('Employee already registered for this session', 'error');
                } else {
                    Toast.error(response.data.message || 'Failed to add member', 'error');
                }
            } catch (err) {
                console.error('Error adding member:', err.response || err);
                if (
                    err.response?.status === 500 &&
                    Array.isArray(err.response.data?.data) &&
                    err.response.data.data[0]?.message === 'employee already registered for this session'
                ) {
                    Toast.error('Employee already registered for this session', 'error');
                } else {
                    Toast.error(err.response?.data?.message || 'Error adding member', 'error');
                }
            }
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-md sessions-modal">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id="staticBackdropLabel">Add Member</h6>
                        <button type="button" className="btn-close font-12" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <label className="font-12 mb-1 regular-text grey-text d-block" htmlFor="employeeEmail">
                                    Employee Email ID
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control font-12"
                                    id="employeeEmail"
                                    placeholder="Enter Email"
                                    value={emailId}
                                    onChange={handleEmailChange}
                                    onBlur={handleEmailBlur}
                                />
                                {error && <p className="text-danger font-12">{error}</p>}
                            </div>

                            {/* Employee Details Fields */}
                            <div className="col-md-12 mb-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="font-12 mb-1 regular-text grey-text d-block" htmlFor="employeeID">
                                            Employee ID
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control font-12"
                                            id="employeeID"
                                            value={employeeDetails.userid || ''}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="font-12 mb-1 regular-text grey-text d-block" htmlFor="employeeName">
                                            Employee Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control font-12"
                                            id="employeeName"
                                            value={employeeDetails.emp_name || ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 mb-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="font-12 mb-1 regular-text grey-text d-block" htmlFor="designation">
                                            Designation
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control font-12"
                                            id="designation"
                                            value={employeeDetails.role || ''}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="font-12 mb-1 regular-text grey-text d-block" htmlFor="practice">
                                            Practice
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control font-12"
                                            id="practice"
                                            value={employeeDetails.practice || ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer border-0">
                        <div className="col-md-12 d-flex justify-content-end">
                            <button className="btn hive-btn-secondary me-3" onClick={onClose}>Cancel</button>
                            <button className="btn hive-btn-primary" onClick={handleAddMember} disabled={!employeeDetails.emp_id}>Add Member</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};